import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';
import { Link } from 'react-router-dom';
import React from "react";
import FaqComponent from "react-faq-component";
import ClearSessionButton from '../components/ClearSessionButton';

function Faq() {
    const data = {
        rows: [
            {
                title: "Quand est prévue la naissance ?",
                content: (
                    <>
                        L'arrivée de notre premier enfant est prévue aux alentours du <b>14 novembre 2026</b>.
                        <br/>
                        Comme toujours avec les naissances, cette date reste indicative : bébé décidera !
                        Nous donnerons des nouvelles dès que possible.
                    </>
                ),
            },
            {
                title: "Comment accéder et contribuer à la liste de naissance ?",
                content: (
                    <>
                        Pour des raisons de confidentialité, la liste de naissance est protégée par une authentification.
                        <br/>
                        La première étape pour y accéder est donc de s'authentifier. Si c'est la première fois, cliquez sur <b>s'inscrire</b> (en haut à droite de l'écran). Vous devriez avoir une page comme ceci :
                        <br/><img src='/static/media/senregistrer.png' alt="Écran d'inscription"></img>
                        Remplir avec votre adresse email. Puis cliquez sur "Next". Vous devriez voir :
                        <br/><img src='/static/media/senregistrer2.png' alt="Écran de saisie du code"></img>
                        Consultez ensuite votre email, vous devriez avoir reçu un email de ce type :
                        <br/><img src='/static/media/senregistrer3.png' alt="Email contenant le code"></img>
                        Récupérez ce code dans vos emails et remplissez le formulaire avec. Enfin cliquez sur "Next".
                        <br/><br/>
                        Bravo, vous devriez être connecté et voir le lien vers la <Link to="/liste-naissance">liste de naissance</Link> dans le menu du haut.
                    </>
                ),
            },
            {
                title: "Comment fonctionne une contribution ?",
                content: (
                    <>
                        Chaque cadeau de la liste affiche un montant cible et le montant déjà collecté.
                        <b>Vous n'êtes pas obligé de financer un cadeau en entier</b> : indiquez simplement le
                        montant que vous souhaitez offrir dans le champ prévu sous le cadeau, même s'il s'agit
                        d'une petite part.
                        <br/><br/>
                        <b>Plusieurs personnes peuvent participer au même cadeau</b> : les contributions
                        s'additionnent et la barre de progression se met à jour au fur et à mesure. C'est
                        particulièrement vrai pour les cadeaux les plus chers, qui ne sont pas pensés pour
                        être offerts par une seule personne.
                        <br/><br/>
                        Vous pouvez sélectionner plusieurs cadeaux : le total de votre contribution s'affiche
                        en bas de l'écran. Cliquez ensuite sur <b>Procéder au paiement</b> pour régler en une
                        seule fois par carte bancaire. Le paiement est traité de manière sécurisée par Stripe :
                        nous n'avons jamais accès à vos coordonnées bancaires.
                        <br/><br/>
                        Une fois le paiement confirmé, le montant collecté du cadeau est mis à jour automatiquement.
                    </>
                ),
            },
            {
                title: "Jusqu'à quand peut-on contribuer à la liste ?",
                content: (
                    <>
                        La liste reste ouverte <b>jusqu'à la naissance</b>, prévue aux alentours
                        du 14 novembre 2026.
                        <br/><br/>
                        Inutile de vous presser pour autant : il n'y a pas de course, et les cadeaux
                        qui ne seraient pas entièrement financés d'ici là ne sont pas perdus, nous
                        compléterons de notre côté.
                    </>
                ),
            },
            {
                title: "Puis-je offrir un cadeau ou envoyer un mot par la poste ?",
                content: (
                    <>
                        Bien sûr, et cela nous fera très plaisir !
                        <br/><br/>
                        Vous pouvez nous envoyer quelque chose <b>dès maintenant</b>, pas besoin
                        d'attendre la naissance.
                        <br/><br/>
                        Notre adresse postale est indiquée sur la <Link to="/">page d'accueil</Link>, visible
                        une fois que vous êtes connecté. Nous ne la publions pas en clair sur le site pour
                        des raisons de confidentialité.
                    </>
                ),
            },
            {
                title: "Puis-je encore voir les photos du mariage ?",
                content: (
                    <>
                        Oui ! La galerie photo du mariage reste accessible dans le menu <b>Galerie</b>,
                        une fois connecté. Elle n'a pas bougé.
                    </>
                ),
            },
            {
                title: "Le bouton se connecter/ s'enregistrer ne marche pas ou la liste de naissance est vide",
                content: (
                    <>
                        Parfois l'authentification peut échouer et le site leslieloic.com est dans ce cas partiellement fonctionnel. Les erreurs rencontrées sont : <br />- le bouton "se connecter" et "s'enregistrer" ne fonctionnent pas. <br />- la liste de naissance est vide.<br />
                        Dans ce cas, cliquez simplement sur ce bouton : <ClearSessionButton />.
                        <br/><br/>
                        Si le problème persiste, essayez de vous déconnecter puis de vous reconnecter, ou
                        d'ouvrir le site dans une fenêtre de navigation privée.
                    </>
                ),
            }
        ],
    };

    const styles = {
        bgColor: null
    }

    return (
        <div>
            <div
            className="hero"
            style={{ backgroundImage: `url(${image})`, height: "250px" }}
            >
                <div className="hero-inner">
                    <div className="inner">
                    <div className="hero-line-one">
                        Foire aux questions
                    </div>
                    </div>
                    <Link className="more-arrow" to="#content">
                    <i className="fa fa-chevron-down"></i>
                    <span>Scroll Down</span>
                    </Link>
                </div>
            </div>
            <div className="wrap full-wrap">
                <div className="main-wrap">
                    <section className="main" style={{paddingLeft: '10px'}}>
                    <FaqComponent
                        data={data}
                        styles={styles}
                    />
                    </section>
                </div>
            </div>
        </div>
    )
}

export default Faq;
